import React from 'react';
import NormieController from './normie-mode/NormieController';
import UserBalances from './normie-mode/UserBalances';
import FeedPeople from './people/FeedPeople';
import DesktopGuard from '@/components/auth/desktop/DesktopGuard';
const DTSearchHome = () => {
  return <div className='h-full flex flex-row gap-4 p-4' data-sentry-component="DTSearchHome" data-sentry-source-file="DTSearchHome.tsx">
      <div className='w-2/3 h-full'>
        <NormieController data-sentry-element="NormieController" data-sentry-source-file="DTSearchHome.tsx" />
      </div>
      <div className='w-1/3 h-full flex flex-col gap-4'>
        <DesktopGuard data-sentry-element="DesktopGuard" data-sentry-source-file="DTSearchHome.tsx">
          <UserBalances data-sentry-element="UserBalances" data-sentry-source-file="DTSearchHome.tsx" />
          {/* TODO: Feedpeople also directly added in DesktopGuard during deposit flow refactor structure so we're only calling it once */}
          <FeedPeople data-sentry-element="FeedPeople" data-sentry-source-file="DTSearchHome.tsx" />
        </DesktopGuard>
      </div>
    </div>;
};
export default DTSearchHome;